<div class="call-buttons" fxLayout="column" fxFlex="1 1 auto" fxFill>
   <button
      class="dial-control-small dial-control-accept"
      fxFlex="1 1 auto"
      kendoButton
      (click)="acceptOrStartCall()"
      [disabled]="!((isCallRingingAndAcceptable$ | async) || (canPhoneMakeCall$ | async))"
   >
      <div class="fa-layers" [ngClass]="{ 'sam-wiggle': (acceptOrStartCallAction$ | async) === 'accept' }">
         <fa-icon
            [icon]="dialArrowIcon"
            transform="shrink-8 right-4 up-6"
            *ngIf="(acceptOrStartCallAction$ | async) === 'dial'"
         ></fa-icon>
         <fa-icon
            [icon]="userDecisionIcon"
            transform="shrink-8 right-4 up-6"
            *ngIf="(acceptOrStartCallAction$ | async) === 'user-decision'"
         ></fa-icon>
         <fa-icon [icon]="phoneAnswerIcon"></fa-icon>
      </div>
   </button>
   <button
      class="dial-control-small dial-control-hang-up"
      fxFlex="1 1 auto"
      kendoButton
      (click)="hangUpPhone()"
      [disabled]="!((isCallInProgress$ | async) || (canDisconnectLineA$ | async))"
   >
      <div class="fa-layers">
         <fa-icon [icon]="phoneHangUpIcon"></fa-icon>
      </div>
   </button>
</div>
